module.exports = __webpack_public_path__ + "img/Watney1.87381e38.png";